import { memo, useCallback, useEffect, useState } from 'react'
import { AccountSignupPage } from 'enums/app'
import { SignupError } from '../signupError/signupError'
import { SignupNewAccount } from './components/signupNewAccount/signupNewAccount'
import { SignupExistingAccount } from './components/signupExistingAccount/signupExistingAccount'
import { useParams } from 'react-router-dom'
import { GetProjectMemberPendingRequest } from '@crew/apis/project/models/getProjectMemberPending/request'
import { skipToken } from '@reduxjs/toolkit/query'
import { useGetProjectMemberPendingQuery } from '@crew/apis/project/projectApis'
import { DestinationType } from '@crew/enums/domain'

export const SignupProjectMember = memo(() => {
  const { invitationToken } = useParams()
  const [signupPage, setSignupPage] = useState<AccountSignupPage | null>(null)

  const getProjectMemberPendingParam:
    | GetProjectMemberPendingRequest
    | undefined = invitationToken
    ? {
        invitationToken,
      }
    : undefined

  const {
    data: getProjectMemberPendingResult,
    isError,
    isLoading,
  } = useGetProjectMemberPendingQuery(getProjectMemberPendingParam ?? skipToken)

  useEffect(() => {
    if (!getProjectMemberPendingResult || isError) {
      setSignupPage(AccountSignupPage.SignupError)
    }

    const projectMemberPending =
      getProjectMemberPendingResult?.projectMemberPending

    // 招待タイプに応じて表示する画面を振り分ける
    if (projectMemberPending?.destinationType === DestinationType.LoginId) {
      //show sign up existing user page if the invitation is for existing account
      setSignupPage(AccountSignupPage.SignupExistingAccount)
    } else if (
      projectMemberPending?.destinationType === DestinationType.Email
    ) {
      //show sign up new user page if the invitation is for new account
      setSignupPage(AccountSignupPage.SignupNewAccount)
    }
  }, [getProjectMemberPendingResult, isError])

  // Render the signup form based on the signup page
  const renderSignupForm = useCallback(() => {
    switch (signupPage) {
      case AccountSignupPage.SignupError:
        return <SignupError />
      case AccountSignupPage.SignupNewAccount:
        return (
          <SignupNewAccount
            projectMemberPending={
              getProjectMemberPendingResult?.projectMemberPending ?? null
            }
          />
        )
      case AccountSignupPage.SignupExistingAccount:
        return (
          <SignupExistingAccount
            projectMemberPending={
              getProjectMemberPendingResult?.projectMemberPending ?? null
            }
          />
        )
      default:
        return null
    }
  }, [getProjectMemberPendingResult?.projectMemberPending, signupPage])

  return !isLoading && renderSignupForm()
})
